import { API_URL, ACTIONS } from "UTILS/Constants";
import BaseAction from "CONFIG/BaseAction";
import { HTTP_METHODS } from "UTILS/Constants";
import Auth from '@aws-amplify/auth';

export class LogoutAction extends BaseAction {
  constructor() {
    super();
    BaseAction.call(this);
  }
  logoutAction() {
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.POST,
        url: API_URL.LOGOUT
      }).then(
        response => {
          resolve(response);
          console.log("Logged Out");
        },
        error => {
          reject(error);
          // this.dispatch({
          //   type: ACTIONS.LOGOUT_SUCCESS
          // });
        }
      );
    });
  }
  // async cognitoSignOut(ssoLogoutUrl) {
  //   try {
  //     Auth.signOut().then(
  //       ()=>console.log("Cognito Signout Success")
  //     ).catch(
  //       ()=>console.log("Cognito Signout failure")
  //     );
  //   } catch (error) {
  //     console.log('error signing out: ', error);
  //   }
  //   const response = await fetch(ssoLogoutUrl, {method: "GET"});
  //   console.log('response: ', response);
  //   if (!response.ok) {
  //     throw Error();
  //   }
  //   return new Promise((resolve, reject) => {
  //     Auth.signOut().then(
  //       response => {
  //         console.log("Cognito Signout Success",response)
  //         resolve(response);
  //       },
  //       error => {
  //         console.log("Cognito Signout failure")
  //         reject(error);
  //       }
  //     );
  //   });
  // }

  logoutreducerAction(){
    this.dispatch({
      type: ACTIONS.LOGOUT_SUCCESS
    });
  }
  
  logoutUser() {
    this.dispatch({
      type: ACTIONS.SET_TOKEN,
      token: null
    });
  }
}
